import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import { DISPLAY_DATE_FORMAT } from '../appConst';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

// Date formatting with IST timezone
export const formatDate = (date, format = DISPLAY_DATE_FORMAT) => {
  return date ? dayjs(date).tz('Asia/Kolkata').format(format) : '-';
};

export const formatDateTime = (datetime) => {
  return datetime ? dayjs(datetime).tz('Asia/Kolkata').format('MMM DD, YYYY hh:mm A') : '-';
};

export const formatTime = (datetime) => {
  return datetime ? dayjs(datetime).tz('Asia/Kolkata').format('hh:mm A') : '-';
};

export const getRelativeTime = (datetime) => {
  return datetime ? dayjs(datetime).fromNow() : '-';
};

// Number formatting
export const formatPercentage = (value, decimals = 1) => {
  return `${Number(value).toFixed(decimals)}%`;
};

export const formatScore = (value, decimals = 2) => {
  return Number(value).toFixed(decimals);
};

// Emotion utilities
export const getTopEmotion = (emotionDistribution) => {
  if (!emotionDistribution || emotionDistribution.length === 0) return null;
  return emotionDistribution.reduce((prev, current) =>
    prev.count > current.count ? prev : current
  );
};

export const getTotalDetections = (emotionDistribution) => {
  if (!emotionDistribution || emotionDistribution.length === 0) return 0;
  return emotionDistribution.reduce((sum, item) => sum + item.count, 0);
};

// String utilities
export const truncate = (str, length = 20) => {
  if (!str) return '';
  return str.length > length ? `${str.substring(0, length)}...` : str;
};

export const capitalize = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

// Array utilities
export const groupBy = (array, key) => {
  return array.reduce((result, item) => {
    const group = item[key];
    if (!result[group]) {
      result[group] = [];
    }
    result[group].push(item);
    return result;
  }, {});
};

// Color utilities
export const hexToRgba = (hex, alpha = 1) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

// Validation
export const isValidEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const isValidEmpId = (empId) => {
  return empId && empId.length >= 3;
};

// Debounce function
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Download utilities
export const downloadImage = (url, filename) => {
  fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
};

// Local storage utilities
export const storage = {
  get: (key, defaultValue = null) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : defaultValue;
    } catch {
      return defaultValue;
    }
  },
  set: (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error('Error saving to localStorage', error);
    }
  },
  remove: (key) => {
    localStorage.removeItem(key);
  },
  clear: () => {
    localStorage.clear();
  }
};
